/**
 * @url /introductioninquiry
 * @CONST CONST.URL_INTRODUCTIONINQUIRT
 * @menu 서비스 요청
 * @mapping 이메일 상담 화면
 */
import React, { useState, useEffect } from "react";
// recoil
import { useRecoilState } from "recoil";
import { urlState, menuInfoState, menuListState } from '../../recoil/menuState';
//css
import "/static/css/swiper.css";
//utils
import clog from "../../utils/logUtils";
import * as CONST from "../../utils/Const";
import * as CUTIL from "../../utils/commUtils";
//component
import Header from "../header/Header";
import EhpImageCrop from "../common/imagecrop/EhpImageCrop";
import EhpDtlPostCode from "../common/postcode/EhpDtlPostCode";
import IntroductionMain from "../Introduction/IntroductionMain";
function IntroductionLayout(props) {
    //recoil
    const [urlInfo, setRecoilUrlInfo] = useRecoilState(urlState);
    const [menuInfo, setRecoilMenuInfo] = useRecoilState(menuInfoState);
    const [menuRecoilList, setRecoilMenuList] = useRecoilState(menuListState);
    //props
    const tabId = props.hasOwnProperty("tabId") ? props.tabId : 0;
    //tab init
    clog("IN LAYOUT : INTOODUCTION : INIT : " + urlInfo);
    const [tabMenuList, setTabMenuList] = useState(null);
    const [curTabMenu, setCurTabMenu] = useState(null);
    // 특정 화면에서 url로 menu 정보 추출하기 위함
    useEffect(() => {
        let tmenuList = menuRecoilList;
        if (tmenuList.length <= 0) {
            //tmenuList = JSON.parse(sessionStorage.getItem(CONST.STR_EHP_MENULIST)); 
        }
        //clog("IN LAYOUT : MANAGEMENT : TMENU LIST : " + JSON.stringify(tmenuList));
        let curMenu = null;
        tmenuList.filter((smenu) => smenu.url === urlInfo).map((smenu, idx) => {
            if (idx === 0)
                curMenu = smenu;
        });
        //clog("IN LAYOUT : MANAGEMENT : CUR MENU : " + JSON.stringify(curMenu));
        const tempTab = [];
        tmenuList.filter((smenu) => (curMenu) && (smenu.parentCode === curMenu.parentCode)).map((smenu, idx) => {
            /*
            if (idx===tabId) {
              setCurTabMenu({
                "tabId":idx,
                "tabName":smenu.menuName,
                "tabUrl":smenu.url,
                "tabType":(smenu.url===CONST.URL_ADMIN)?"TAB_ZONE":(smenu.url===CONST.URL_ADMIN_ITEM)?"TAB_DEVICE":""
              });
            }*/
            tempTab.push({
                "tabId": idx,
                "tabName": smenu.menuName,
                "tabUrl": smenu.url,
                "tabType": (smenu.url === CONST.URL_DEVICESLIFE) ? "TAB_ZONE" : (smenu.url === CONST.URL_DEVICESLIFEREPORT) ? "TAB_DEVICESLIFEREPORT" : ""
            });
        });
        setTabMenuList(tempTab);
        //clog("IN LAYOUT : MANAGEMENT : TMENU LIST : " + JSON.stringify(tempTab));
        setCurTabMenu(tempTab[tabId]);
    }, [urlInfo, tabId, menuRecoilList]);
    //
    const [popUserApprrval, setPopUserApprrval] = useState(React.createElement(UserApprrvalPop, { popBody: null }));
    const [popSiteCeatePop, setPopSiteCeatePop] = useState(React.createElement(SiteCeatePop, { popBody: null }));
    const [popSmall, setPopSmall] = useState(React.createElement(SmallPop, { popBody: null }));
    const [popUserRole, setPopUserRole] = useState(React.createElement(UserRolePop, { popBody: null }));
    // 공통 - crop
    const [popImgCrop, setPopImgCrop] = useState(React.createElement(EhpImageCrop, { popBody: null }));
    // 공통 - postcode
    const [popPostCode, setPopPostCode] = useState(React.createElement(EhpDtlPostCode, { popBody: null }));
    useEffect(() => {
        //setCurTabMenu(tabMenuList[tabId]);
    }, [tabId]);
    useEffect(() => {
        setPopUserApprrval(popUserApprrval);
        setPopSiteCeatePop(popSiteCeatePop);
        setPopSmall(popSmall);
        setPopUserRole(popUserRole);
        // 공통
        setPopImgCrop(popImgCrop);
        setPopPostCode(popPostCode);
    }, [popUserApprrval, popSiteCeatePop,
        popSmall, popUserRole,
        popImgCrop, popPostCode, // 공통
    ]);
    function handlePopWin(popType, popObj) {
        if (popType === "pop-userjoin-ok") {
            setPopUserApprrval(React.createElement(UserApprrvalPop, { popBody: popObj }));
        }
        else if (popType === "pop-userjoin-info") {
            setPopSiteCeatePop(React.createElement(SiteCeatePop, { popBody: popObj }));
        }
        else if (popType === "pop-small") {
            setPopSmall(React.createElement(SmallPop, { popBody: popObj }));
        }
        else if (popType === "pop-imgcrop") { //////////////////////////////////////////////////
            setPopImgCrop(React.createElement(EhpImageCrop, { popBody: popObj }));
        }
        else if (popType === "pop-dtlpostcode") {
            setPopPostCode(React.createElement(EhpDtlPostCode, { popBody: popObj }));
        }
        else if (popType === "pop-role") {
            setPopUserRole(React.createElement(UserRolePop, { popBody: popObj }));
        }
        //
    }
    function handleCurTabMenu(tab) {
        // 승인 관리
        setPopUserApprrval(React.createElement(UserApprrvalPop, { popBody: null }));
        setPopSiteCeatePop(React.createElement(SiteCeatePop, { popBody: null }));
        setPopSiteCeatePop(React.createElement(SiteCeatePop, { popBody: null }));
        setPopUserRole(React.createElement(UserRolePop, { popBody: null }));
        // 공통
        setPopImgCrop(React.createElement(EhpImageCrop, { popBody: null }));
        setPopPostCode(React.createElement(EhpDtlPostCode, { popBody: null }));
        //
        setCurTabMenu(tab);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "wrap", className: "email" },
            React.createElement(Header, null),
            (tabMenuList) && (curTabMenu) &&
                React.createElement(IntroductionMain, { setPopWin: handlePopWin, tabMenuList: tabMenuList, curTabMenu: curTabMenu, setCurTabMenu: handleCurTabMenu })),
        popUserApprrval,
        popSiteCeatePop,
        popSmall,
        popUserRole,
        popImgCrop,
        popPostCode));
}
export default IntroductionLayout;
// 닫기버튼 추가 팝업
function UserApprrvalPop(props) {
    const popBody = props.popBody;
    const htmlHeader = (!CUTIL.isnull(popBody))
        ? popBody.hasOwnProperty("props")
            ? popBody.props.hasOwnProperty("htmlHeader")
                ? popBody.props.htmlHeader
                : null
            : null
        : null;
    const htmlHeaderBtn = (!CUTIL.isnull(popBody))
        ? popBody.props.hasOwnProperty("htmlHeaderBtn")
            ? popBody.props.htmlHeaderBtn
            : null
        : null;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "pop-userjoin-ok", className: "popup-layer js-layer layer-out hidden page-detail userjoin-ok" },
            React.createElement("div", { className: "popup__head" },
                (htmlHeader) && htmlHeader,
                (htmlHeaderBtn) && htmlHeaderBtn),
            (CUTIL.isnull(popBody))
                ? React.createElement(React.Fragment, null)
                : popBody)));
}
// 기본 팝업
function SiteCeatePop(props) {
    const popBody = props.popBody;
    const htmlHeader = (!CUTIL.isnull(popBody))
        ? popBody.hasOwnProperty("props")
            ? popBody.props.hasOwnProperty("htmlHeader")
                ? popBody.props.htmlHeader
                : null
            : null
        : null;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "pop-userjoin-info", className: "popup-layer js-layer hidden page-detail userjoin-ok" },
            React.createElement("div", { className: "popup__head" },
                (htmlHeader) && htmlHeader,
                React.createElement("button", { className: "btn btn-close js-close" },
                    React.createElement("span", { className: "hide" }, "\uB2EB\uAE30"))),
            (CUTIL.isnull(popBody))
                ? React.createElement(React.Fragment, null)
                : popBody)));
}
// 작은 팝업
function SmallPop(props) {
    const popBody = props.popBody;
    const htmlHeader = (!CUTIL.isnull(popBody))
        ? popBody.hasOwnProperty("props")
            ? popBody.props.hasOwnProperty("htmlHeader")
                ? popBody.props.htmlHeader
                : null
            : null
        : null;
    const htmlHeaderBtn = (!CUTIL.isnull(popBody))
        ? popBody.props.hasOwnProperty("htmlHeaderBtn")
            ? popBody.props.htmlHeaderBtn
            : null
        : null;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "pop-small", className: "popup-layer js-layer hidden layer-out popup-basic" },
            React.createElement("div", { className: "page-detail" },
                React.createElement("div", { className: "popup__head" },
                    (htmlHeader) && htmlHeader,
                    (htmlHeaderBtn) && htmlHeaderBtn),
                (CUTIL.isnull(popBody))
                    ? React.createElement(React.Fragment, null)
                    : popBody))));
}
// 아주 작은 팝업
function UserRolePop(props) {
    const popBody = props.popBody;
    const htmlHeader = (!CUTIL.isnull(popBody))
        ? popBody.hasOwnProperty("props")
            ? popBody.props.hasOwnProperty("htmlHeader")
                ? popBody.props.htmlHeader
                : null
            : null
        : null;
    const htmlHeaderBtn = (!CUTIL.isnull(popBody))
        ? popBody.props.hasOwnProperty("htmlHeaderBtn")
            ? popBody.props.htmlHeaderBtn
            : null
        : null;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "pop-role", className: "popup-layer popup-basic hidden page-detail w400" },
            React.createElement("div", { className: "popup__head" },
                (htmlHeader) && htmlHeader,
                (htmlHeaderBtn) && htmlHeaderBtn),
            (CUTIL.isnull(popBody))
                ? React.createElement(React.Fragment, null)
                : popBody)));
}
function handelClose(e) {
    window.location.reload();
}
